export default __webpack_public_path__ + "static/rui-33769dd03fb08a08dd8a73c0be705a0a.jpg";